export const sessionTypes = {
  SHOW_BANNER: "SHOW_BANNER"
};

export const setShowBanner = showBanner => ({
  type: sessionTypes.SHOW_BANNER,
  payload: {
    showBanner
  }
});
